export default __webpack_public_path__ + "static/media/cp_geo_kn.43bc298c.svg";